$(document).ready(function () {
  
    $('form').append("<input type='hidden' name='idemp_key' value='"+uuid4()+"'>");
  
    $('.navbar-collapse').on('show.bs.collapse', function () {
      if ($(window).scrollTop() < 66) {
        $("body,html").animate({
            scrollTop: 66
        }, 200);
      }
      
      $('html').addClass('nav-is-open');
      $('html').removeClass('nav-is-closed');
    });
    
    $('.navbar-collapse').on('shown.bs.collapse', function () {
      $('html').addClass('nav-is-open');
      $('html').removeClass('nav-is-closed');
    });
    
    $('.navbar-collapse').on('hide.bs.collapse', function () {
      $('html').removeClass('nav-is-open');
      $('html').addClass('nav-is-closed');
    });
    
    $('.navbar-collapse').on('hidden.bs.collapse', function () {
      $('html').removeClass('nav-is-open');
      $('html').addClass('nav-is-closed');
    });
    
    // var navAnchors = document.querySelectorAll('.navbar-collapse a[href^="https://nevatrip.ru/#"');
  
    // for (var item of navAnchors) {
    //     item.addEventListener('click', () => {
    //         $(".collapse").collapse('hide')
    //         $('html').removeClass('nav-is-open');
    //         $('html').addClass('nav-is-closed');
    //     });
    // }
    
    // var anchor = window.location.hash; // Закомментировали, потому что не работает якорь из меню.
    // $(".collapse").collapse('hide');
    // $(anchor).collapse('show');
    
    
    $('#modalVideo').on('hidden.bs.modal', function (e) {
       var leg=$('#videoBanner').attr("src");
       $('#videoBanner').attr("src",leg);
    });//перезапускаем видео, чтобы при закрытии видео остановилось
    
    
    $('#modalStayHome').on('hidden.bs.modal', function (e) {
      // console.log( 'stay home закрыт' );
       $("#modalStayHomeInner").empty();
    });
    
    
    $('#modalStayHome').on('shown.bs.modal', function (e) {
      // console.log( 'stay home открыт' );
       $('#modalStayHomeInner').prepend('<p id="modalStayHomeLabel" style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:600;font-size:20px;line-height:1.2;color:#419DCD;margin-bottom:14px;"><noindex>#ОстаёмсяДома</noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:600;font-size:24px;line-height:1.2;color:#000000;margin-bottom:14px;"><noindex>Что мы думаем об этом всём...</noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>Первые дни частичного карантина волшебным образом преображают территории и меняют привычки людей. Города пустеют, люди сидят по домам, и только отчаянные доставщики еды мчатся, как всадники, в своих униформах, чтобы снабдить нас очередной порцией гречки или вкусным маффином. </noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>Еще месяц назад никто себе не мог представить, что такое возможно. Что с первыми теплыми и солнечными деньками мы с вами будем отменять наши грандиозные планы на предстоящий год: концерты, фестивали, поездки, дни рождения в кругу друзей и близких, свидания в огнях вечернего города с любимым человеком на теплоходе-ресторане. Всё это теперь стало невозможным! Все это стало неважным, когда на первое место вышла наша с вами безопасность, здоровье и будущее наших близких. </noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>Мы с вами являемся свидетелями исторического события: весь мир, каждый человек на этой планете Земля как никогда близки друг другу. Американец ли ты, японец или житель небольшого непальского городка, ты чувствуешь то, что чувствует житель Австралии, Мексики и Италии. Сейчас мы с вами  - жители одного мира, который переживает революцию сознания. Рано или поздно все закончится, и только от нас с вами зависит какой мир мы захотим увидеть. Будет ли он одинок, слаб и беден или он будет открытым, окрепшим и дающим нам новые возможности.</noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>Не бывает лучшего момента, чем прямо сейчас стать сильнее, поверить в себя и войти в новую реальность с высоко поднятой головой и с горящими глазами! Время перемен - это время, когда мы сами своими руками превращаем наши желания и мечты в реальность!</noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>Несмотря на то, что туристический сезон для всех нас в этом году скорее всего пройдет без привычных улыбок и фотографий, новых впечатлений и взаимных теплых благодарностей и пожеланий, команда Неватрип посвятит это время, чтобы стать лучше и полезней для Вас. Мы будем ждать того момента, когда первыми встретим вас в наших любимых городах, обнимем, покажем и расскажем взахлеб и с нетерпением об этом новом, чудесном и прекрасном мире.</noindex></p><p style="font-family: &quot;Open Sans&quot;, sans-serif;font-weight:400;font-size:18px;line-height:1.3;color:#2B2A2A"><noindex>С искренней любовью и теплом, команда НеваТрип! ❤️</noindex></p>');
    });
    
    
  // if ($(window).scrollTop() > 70 && window.innerWidth >= 992)  {
  //   $('#NavScrollSpy').css('height', `0px`);
  //   $('#NavScrollSpy .hidden-xs.hidden-sm').css('display', `none`);
  // }
      
  // function reduceNav() {
  //   if (window.innerWidth >= 992) {
  //     window.addEventListener('scroll', function() {
  //       var windowScroll = $(window).scrollTop();
  //       var navHeight = 66 - (windowScroll - 70) + 3;
      
  //       if (windowScroll > 73 && windowScroll < 166) {
  //         $('#NavScrollSpy').css('height', `${navHeight}px`);
  //         $('#NavScrollSpy .hidden-xs.hidden-sm').css({'display': `inline`, 'opacity': 1 - windowScroll * 0.011});
  //       } else if (windowScroll >= 166) {
  //         $('#NavScrollSpy').css('height', `45px`);
  //         $('#NavScrollSpy .hidden-xs.hidden-sm').css('display', `none`);
  //       } else if (windowScroll < 70) {
  //         $('#NavScrollSpy').css('height', `66px`);
  //         $('#NavScrollSpy .hidden-xs.hidden-sm').css({'display': `inline`, 'opacity': 1});
  //       }
  //     });
  //   }
  // }
  
  // reduceNav();
  
  // window.addEventListener("resize", function() {
  //   if (window.innerWidth >= 992) {
  //     reduceNav();
  //   }
  // });
  
  $('[data-toggle="custom-tooltip"]').tooltip({
      trigger: 'hover'
    }); 
  
    $(".group-incr > .input-group-addon").click(function(e){
      let elem = $(e.target);
      
      let input = elem.parent().children("input.incr-input");
      
      if(elem.hasClass("incr-minus")){
        //let input = elem.next();
        let value = parseInt(input.val());
        
        if(value <= input.attr("min")){
          return;
        }
        
        input.val(value - 1);
      } else if(elem.hasClass("incr-plus")) {
        //let input = elem.prev();
        input.val(parseInt(input.val()) + 1);
      }
    });
  });
  
  
  function showLangs () {
  var blocks = $('.js-langs');
  
  blocks.each(function() {
        var block = $( this );
        var link = $( this ).find('.js-langs-link');
        var icon = $( this ).find('.js-langs-svg');
        var flag = false;
        
        $( this ).click(function() {
            (link.css('display') === 'none') ? link.slideDown(200) : link.slideUp(200);
            icon.toggleClass('langs__svg_active');
            flag = true;
        });
        
        document.addEventListener('click', function(e) {
            if (!(block.find( $( e.target ) ).length) && flag === true) {
                link.slideUp(200);
                if (icon.hasClass('langs__svg_active')) icon.toggleClass('langs__svg_active');
                flag = false;
            }
        });
  });
  }
  
  showLangs();
  
  function showNavbar() {
  var navbar = $('.js-hidden-navbar');
  var header = $('body > .topbar');
  var headerBtn = document.querySelector('.topbar .js-desktop-navbar-btn');
  var navBtn = document.querySelector('.navbar .js-navbar-btn');
  var optionalNavbar = $('.js-optional-navbar');
  var optionalNavbarContent = $('.js-navbar-optional-content');
  var wrapper = $('.navbar.navbar-inverse');
  var mainContent = $('.navbar.navbar-inverse + style + div');
  var headerInNav = document.querySelector('.js-header-in-nav');
  var slider = $('.nav-boards__list');
  
  function openNavInMobile() {
    function openNav() {
      $('body').addClass('body_view_open_nav');
      wrapper.addClass('navbar-open');
      navbar.css('left', '-100%');
      navbar.css('display', 'block');
      optionalNavbar.css('display', 'block');
      navbar.animate({left: '0'}, 450);
      $('.js-optional-navbar').css({'height': 'auto'});
  
      if (window.innerWidth < 768) {
        wrapper.css('min-height', '100vh');
        $('.navbar-header').css('box-shadow', '0px 4px 4px rgba(0, 0, 0, 0.25)');
      }
    }
      
    if (!wrapper.hasClass('open-header-on-mobile')){
      wrapper.removeClass('open-header-on-desktop');
      wrapper.addClass('open-header-on-mobile');
      $('.navbar .js-desktop-navbar-btn').addClass('navbar-active-icon-btn');
  
      if (window.scrollY === 0) {
        wrapper.addClass('navbar-open-with-header');
        headerInNav.style.display = 'block';
        headerInNav.style.visibility = 'visible';
  
        openNav();
      } else if (window.scrollY <= 65 ) {
        $('html, body').animate({
          scrollTop: 0
        }, 200, function () {
          wrapper.addClass('navbar-open-with-header');
          headerInNav.style.display = 'block';
          headerInNav.style.visibility = 'visible';
  
          openNav();
        });
        return false;
      } else {
        openNav();
      }
  
    } else {
      wrapper.removeClass('open-header-on-mobile');
      $('.navbar .js-desktop-navbar-btn').removeClass('navbar-active-icon-btn');
      wrapper.removeClass('navbar-open-with-header');
      headerInNav.style.display = 'none';
      headerInNav.style.visibility = 'hidden';
  
      $('body').removeClass('body_view_open_nav');
      wrapper.removeClass('navbar-open');
      navbar.animate({left: '-100%'}, 450);
  
      if (window.scrollY < 10) {
        wrapper.addClass('navbar-open_position_fixed');
      }
  
      navbar.css({'display': 'block'});
      optionalNavbar.css({'display': 'block'});
      //wrapper.css('min-height', 'auto');
  
      setTimeout(function() {
        wrapper.removeClass('navbar-open_position_fixed');
        optionalNavbar.css('display', 'none');
        navbar.css({'display': 'none', 'left': '0'});
        $('.nav-is-open').css('overflow', 'auto');
  
        if (window.innerWidth < 768) {
          wrapper.css('min-height', 'initial');
          $('.navbar-header').css('box-shadow', 'none');
        }
      }, 450);
    }
  }
  
  if(navBtn){
    navBtn.addEventListener('click', openNavInMobile);
  }
  
  function openNavInDesktop() {
    if (!wrapper.hasClass('open-header-on-desktop')) {
        $('html, body').animate({
          scrollTop: 0
        }, 300, function () {
      wrapper.removeClass('open-header-on-mobile');
      wrapper.addClass('open-header-on-desktop');
  
      optionalNavbar.slideDown(450);
      $('.topbar .js-desktop-navbar-btn').addClass('navbar-active-icon-btn');
  
      showScrollOnMenu();
  
      document.body.addEventListener('click', function(e) {
        if (e.target === document.body) {
          closeHeaderNav();
        }
      });
        });
    } else {
      wrapper.removeClass('open-header-on-desktop');
      document.body.removeEventListener('click', function() {});
      closeHeaderNav();
    }
  }
  
  $(headerBtn).on('click', openNavInDesktop);
  
  $(window).resize(function () {
    if (window.innerWidth > 768) {
      if (wrapper.hasClass('open-header-on-mobile')) {
        openNavInMobile();
        setTimeout(openNavInDesktop, 500);
      }
    } else {
      if (wrapper.hasClass('open-header-on-desktop')) {
        openNavInDesktop()
        openNavInMobile();
      }
    }
  });
  
  $('.js-optional-navbar li > a[href^="https://nevatrip.ru/#"').on('click', function() {
    if (wrapper.hasClass('open-header-on-mobile')) {
        openNavInMobile();
    } else if (wrapper.hasClass('open-header-on-desktop')) {
      openNavInDesktop();
    }
  });
  }
  showNavbar();
  
  function closeHeaderNav() {
  var headerBtn = document.querySelector('.topbar .js-desktop-navbar-btn');
  var optionalNavbar = $('.js-optional-navbar');
  var innerNav = $('.navbar-nav_inner');
  
  optionalNavbar.slideUp(400);
    
  headerBtn.classList.remove('navbar-active-icon-btn');
  $('.js-more-excursion').removeClass('active');
  $('body').addClass('body_view_closing_nav');
  // setTimeout(function() {
    $('body').removeClass('body_view_open_nav body_view_closing_nav');
  // }, 200)
  }
  
  function showScrollOnMenu() {
  $('body').addClass('body_view_open_nav');
    if (document.querySelector('body > .topbar').offsetHeight + document.querySelector('.js-hidden-navbar').offsetHeight + document.querySelector('.js-navbar-optional-content').offsetHeight + 92 > window.innerHeight) {
      var innerNavHeight = window.innerHeight - document.querySelector('body > .topbar').offsetHeight - document.querySelector('.js-hidden-navbar').offsetHeight + 'px';
  
      setTimeout(function() {
        $('.js-optional-navbar').css({'overflow': 'auto', 'height': innerNavHeight});
      }, 1000);
    }
  // }
  }
  
  function showMoreExcursion() {
  var button = $('.js-more-excursion');
  var block = $('.navbar-nav_inner');
  var text = button.text();
  var optionalNavbar = $('.js-optional-navbar');
  
  button.click(function() {
    if (block.css('height') !== '150px') {
      button.text( text );
      block.css({'height': '150px'});
      button.removeClass('active');
      optionalNavbar.css('overflow', 'hidden');
      setTimeout(function() {
        showScrollOnMenu();
      }, 0)
    } else {
      button.text( text.replace('Больше подборок', 'Cкрыть подборки') );
      block.css({'height': '100%'});
      button.addClass('active');
      optionalNavbar.css('overflow', 'hidden');
      setTimeout(function() {
        showScrollOnMenu();
      }, 0)
    }
  });
  }
  
  showMoreExcursion();
  
  function stickyNav() {
  var wrapper = $('.navbar.navbar-inverse');
  
  window.addEventListener('scroll', function() {
    if (window.pageYOffset > 90) {
      wrapper.addClass('affix');
      wrapper.removeClass('affix-top');
    } else {
      wrapper.addClass('affix-top');
      wrapper.removeClass('affix');
    }
  });
  }
  stickyNav();
  
  function openInnerCollectionsOnDesktop () {
  var buttons = $('.js-open-inner-colection');
  buttons.on("click", function(e) {
    buttons.siblings('ul').slideUp();
    buttons.removeClass('active');
  
    var collection = $(this).siblings('ul');
    if (collection.css('display') === 'none') {
      collection.slideDown();
      $(this).addClass('active');
    } else {
      collection.slideUp();
      $(this).removeClass('active');
    };
  });
  }
  openInnerCollectionsOnDesktop();
  
  function openInnerCollectionsOnMobile() {
  $('.js-open-podborki').click(function(e) {
    if ($('#podborki').css('display') === 'block') {
      $('.js-open-podborki').addClass('collapsed');
      $('#podborki').slideUp();
    } else {
      $('#podborki').slideDown();
      $('.js-open-podborki').removeClass('collapsed');
    }
  });
  }
  openInnerCollectionsOnMobile();
  
  $('.js-optional-navbar li > a[href^="https://nevatrip.ru/#"').on('click', function() {
  var wrapper = $('.navbar.navbar-inverse');
  
  if (wrapper.hasClass('open-header-on-mobile')) {
    openNavInMobile();
  } else if (wrapper.hasClass('open-header-on-desktop')) {
    openNavInDesktop();
  }
  });
  
  document.addEventListener("DOMContentLoaded",function(){ 
    var elements = document.getElementsByTagName('textarea');
    for(var i = 0; i < elements.length; i++){
      elements[i].addEventListener('keyup', function(e){
        var target = e.target;
        
        // Сохраняем текущую позицию скролла
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        target.style.height = '';

        if(target.scrollHeight > 120){
          target.style.height = target.scrollHeight + 'px';
        }
        
        // Восстанавливаем позицию скролла
        window.scrollTo(0, scrollTop);
      });
    };
  });
  
  function uuid4() {
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
  }